/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OAuthAppInventoryMetadata } from './oAuthAppInventoryMetadata';
import { OAuthAppAwsAccountCategoryEnum } from './oAuthAppAwsAccountCategoryEnum';


export interface OAuthAppInventoryCommon { 
    name?: string;
    description?: string;
    secret_manager_path?: string;
    account_type?: OAuthAppAwsAccountCategoryEnum;
    metadata?: OAuthAppInventoryMetadata;
    secret_rotation_timestamp?: Date;
    secret_rotated_by?: string;
}
export namespace OAuthAppInventoryCommon {
}


